/**
 * Echarts
 * 
 * @Author: Focci
 * @Date: 2023-09-25 14:03:31
 * @Last Modified by: Focci
 * @Last Modified time: 2023-09-25 14:03:31
 */

'use client'

import useLazyComponent from '@hook/useLazyComponent'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { Waypoint } from 'react-waypoint'

export default function Echarts({
  style,
  ...props
}) {
  const { Wedget: EchartsIns, getWedget } = useLazyComponent()
  const handleEnter = useCallback(async () => {
    getWedget(() => import('echarts-for-react'))
  }, [getWedget])

  return (
    <Waypoint onEnter={handleEnter}>
      <div style={style}>
        <EchartsIns style={style} {...props} />
      </div>
    </Waypoint>
  )
}

Echarts.propTypes = {
  style: PropTypes.object,
}
